// Helper immagini — FASE 5 (ottimizzazione).
// Le varianti WebP compresse vivono in un prefisso NUOVO su S3 ("/optimized/...")
// e NON sostituiscono gli originali (che restano il fallback dentro <img>/<picture>).
// webpVariant() calcola l'URL della variante WebP solo per le immagini dinamiche
// servite da /images/products/ e /images/news/. Per tutto il resto ritorna null
// (il chiamante usa il solo <img> originale).
export const webpVariant = (src) => {
  if (!src || typeof src !== 'string') return null;
  // solo path relativi serviti dal nostro bucket
  const m = src.match(/^\/images\/(products|news)\/([^/?#]+)\.(png|jpe?g|webp)$/i);
  if (!m) return null;
  const [, folder, base] = m;
  return `/optimized/${folder}/${base}.webp`;
};

export default webpVariant;
